import React, {useState, useContext, useRef, useEffect} from "react"

// context
import {SearchContext} from "../../../../context";
import {CatalogueContext} from "../../../../context";

// styling
import "./Heading.scss"

let isFirstLoad = true


function Heading() {
  // state management
  const [sortBy, setSortBy] = useState("sales_rank")

  // references
  const refTop = useRef()

  // context
  const catalogue = useContext(CatalogueContext);
  const search = useContext(SearchContext);

  // we want the view to scroll up each time the search result changes
  useEffect(() => {
    if(!isFirstLoad) {
      //scrollToTop()
    }
    if(isFirstLoad && search.result.length > 0) {
      isFirstLoad = false
    }
  }, [search.result])

  // scrolls to the top of the search result
  const scrollToTop = () => {
    if(refTop.current) {
      // scroll to top
      let offset = -160 // to accomated the fixed header and heading
      window.scrollTo({
        top:refTop.current.offsetTop + offset,
        behavior: 'smooth'
      })
    }
  }

  // click event handler
  const onClickSort = (value) => {
    if(value !== setSortBy) {
      setSortBy(value)
      search.sort(value)
      scrollToTop()
    }
  }

  // render
  let heading = "";
  let resetInfo = null;

  if(search.subcatalogue === "singles") {
    heading = `Wähle aus ${catalogue.activities.standard.length} Erlebnissen`; // "Schenke ein unvergessliches Erlebnis";
    if(search.result.length !== catalogue.activities.standard.length) {
      if(search.result.length === 0) {
        heading = "leider nichts gefunden";
      }
      else {
        if(search.tagsTitle && search.tagsTitle.trim().length > 0) {
          heading = `${search.result.length} ${search.tagsTitle} gefunden`
        }
        else {
          heading = `${search.result.length} Erlebnisse gefunden`
        }
        resetInfo = (
          <div className="reset">
            <div className="reset-button" onClick={() => search.reset()}>alle Erlebnisse anzeigen ({catalogue.activities.standard.length})</div>
          </div>
        );
      }
    }
  }
  else {
    heading =`Wähle aus ${catalogue.activityPackages.length} Erlebnis-Kombinationen`;
    if(search.resultPackages.length !== catalogue.activityPackages.length) {
      if(search.resultPackages.length === 0) {
        heading = "leider nichts gefunden";
      }
      else {
        heading = `${search.resultPackages.length} Erlebnis-Kombinationen gefunden`
      }
      resetInfo = (
        <div className="reset">
          <div className="reset-button" onClick={() => search.reset()}>alle Erlebniskombinationen anzeigen ({catalogue.activityPackages.length})</div>
        </div>
      );
    }
  }
  
  return (
    <>
    <div id="v-search-heading">
      <div className="count-and-reset">
        <h1>{heading}</h1>
        {resetInfo}
      </div>
      
      <div className="sort">
        <div className="label">Sortieren nach</div>
        <div className="options">
          {
            search.subcatalogue === "singles" ? 
            <div className={`sort-option ${sortBy==="sales_rank" ? 'active':'passive'}`} onClick={() => onClickSort('sales_rank')}>
              Beliebteste
            </div>
            :
            null
          }
          
          <div className={`sort-option ${sortBy==="price_up" ? 'active':'passive'}`} onClick={() => onClickSort('price_up')}>
            Günstigste
          </div>
          <div className={`sort-option ${sortBy==="price_down" ? 'active':'passive'}`} onClick={() => onClickSort('price_down')}>
            Teuerste
          </div>
        </div>
      </div>
    </div>
    <div ref={refTop} />
    </>
  )
}

export default Heading

